import { render, staticRenderFns } from "./Breakdown.vue?vue&type=template&id=c270900c&scoped=true&"
import script from "./Breakdown.vue?vue&type=script&lang=ts&"
export * from "./Breakdown.vue?vue&type=script&lang=ts&"
import style0 from "./Breakdown.vue?vue&type=style&index=0&id=c270900c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c270900c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VImg,VLayout})
